import './App.css';
import Index from './Componants/Section1/Index';
import Header from './Componants/Navbar/Header';
import Class from './Componants/Section2/Class';
import Index2 from './Componants/Section3/Index';
import Index3 from './Componants/Section4/Index';
import Index4 from './Componants/Section5/Index';
import Index5 from './Componants/Section6/Index';
import Index6 from './Componants/Section7/Index';
function App() {
  return (
    <>
      <Header/>
      <Index/>
      <Class/>
      <Index2/>
      <Index3/>
      <Index4/>
      <Index5/>
      <Index6/>
    </>
  );
}

export default App;
